import React, { useState } from 'react';
import '../App.css';

function Login({ onLogin, onRequestPasswordReset, onResetPassword }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showResetModal, setShowResetModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await onLogin(email, password);

      if (!result.success) {
        setError(result.error || 'Invalid email or password');
        setLoading(false);
      } else {
        // Login successful - loading will be handled by parent component
        console.log('Login successful');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message || 'Login failed');
      setLoading(false);
    }
  };

  return (
    <div className="login-container" style={{ minHeight: '100vh', display: 'flex', position: 'relative' }}>
      <style dangerouslySetInnerHTML={{ __html: `
        body, * {
          font-family: 'NeueHaasUnica', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif !important;
        }
        h1, h2, h3, h4, h5, h6 {
          font-family: 'Domaine Text', 'Georgia', serif !important;
        }
        
        /* Mobile: Overlay login form on background */
        @media (max-width: 768px) {
          .login-container {
            flex-direction: column !important;
          }
          .login-form-container {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            bottom: 0 !important;
            background: rgba(255, 255, 255, 0.75) !important;
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            z-index: 10 !important;
            padding: 32px 24px !important;
            overflow-y: auto !important;
          }
          .login-visual-container {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            bottom: 0 !important;
            z-index: 1 !important;
          }
        }
        
        @media (min-width: 769px) {
          .login-form-container {
            position: relative !important;
            background: white !important;
          }
          .login-visual-container {
            position: relative !important;
          }
        }
      ` }} />
      
      {/* Left Side - Login Form */}
      <div className="login-form-container" style={{ 
        flex: '0 0 50%', 
        backgroundColor: 'white', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '40px'
      }}>
        <div style={{ maxWidth: '400px', width: '100%' }}>
          {/* Brand Mark */}
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            {/* Icon/Brand Mark */}
            <img 
              src="/mayker_icon-black.svg" 
              alt="Mayker Delivery Portal" 
              style={{ height: '60px', width: 'auto', marginBottom: '24px', display: 'block', margin: '0 auto 24px auto' }}
              onError={(e) => {
                console.error('Icon failed to load:', e.target.src);
                // Try alternative paths if image not found
                if (!e.target.src.includes('.png')) {
                  e.target.src = '/mayker_icon-black.png';
                } else if (!e.target.src.includes('/assets/')) {
                  e.target.src = '/assets/mayker_icon-black.svg';
                } else {
                  console.error('Icon image not found - all paths failed');
                }
              }}
            />
            {/* Mayker Delivery Portal Title */}
            <h1 style={{ 
              fontSize: '24px',
              fontWeight: '200',
              color: 'var(--brand-charcoal)',
              margin: '0',
              fontFamily: "'Domaine Text', serif",
              letterSpacing: '-0.02em'
            }}>
              Mayker Delivery Portal
            </h1>
          </div>
          
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{ 
                backgroundColor: '#fee2e2', 
                color: '#dc2626', 
                padding: '12px', 
                borderRadius: '6px', 
                marginBottom: '24px', 
                fontSize: '14px' 
              }}>
                {error}
              </div>
            )}
            {loading && !error && (
              <p style={{
                fontSize: '13px',
                color: '#6b7280',
                marginBottom: '20px',
                lineHeight: 1.45
              }}>
                Signing in can take up to a minute when the Google backend is waking up. Please wait…
              </p>
            )}
            
            <div style={{ marginBottom: '24px' }}>
              <label style={{ 
                display: 'block', 
                fontSize: '14px', 
                fontWeight: '500', 
                marginBottom: '8px', 
                color: '#000000' 
              }}>
                Email:
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ 
                  width: '100%', 
                  padding: '14px', 
                  border: '1px solid #d1d5db', 
                  borderRadius: '6px', 
                  fontSize: '15px', 
                  boxSizing: 'border-box',
                  backgroundColor: 'white'
                }}
                placeholder="Enter your email"
              />
            </div>
            
            <div style={{ marginBottom: '32px' }}>
              <label style={{ 
                display: 'block', 
                fontSize: '14px', 
                fontWeight: '500', 
                marginBottom: '8px', 
                color: '#000000' 
              }}>
                Password:
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ 
                  width: '100%', 
                  padding: '14px', 
                  border: '1px solid #d1d5db', 
                  borderRadius: '6px', 
                  fontSize: '15px', 
                  boxSizing: 'border-box',
                  backgroundColor: 'white'
                }}
                placeholder="Enter your password"
              />
            </div>
            
            {/* Buttons Row */}
            <div style={{ 
              display: 'flex', 
              gap: '12px', 
              marginBottom: '24px' 
            }}>
              <button
                type="button"
                onClick={() => {
                  setShowResetModal(true);
                  setError('');
                }}
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  backgroundColor: 'transparent',
                  color: '#000000',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  fontFamily: "'NeueHaasUnica', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'var(--brand-charcoal)';
                  e.currentTarget.style.backgroundColor = '#f9fafb';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#d1d5db';
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                Forgot Your Password
              </button>
              
              <button
                type="submit"
                disabled={loading}
                style={{
                  flex: 1,
                  padding: '14px',
                  backgroundColor: 'var(--brand-charcoal)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '15px',
                  fontWeight: '500',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1,
                  transition: 'opacity 0.2s ease',
                  fontFamily: "'NeueHaasUnica', sans-serif"
                }}
                onMouseOver={(e) => {
                  if (!loading) {
                    e.target.style.opacity = '0.9';
                  }
                }}
                onMouseOut={(e) => {
                  if (!loading) {
                    e.target.style.opacity = '1';
                  }
                }}
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            </div>
          </form>
          
          {/* Password Reset Modal */}
          {showResetModal && (
            <PasswordResetModal
              isOpen={showResetModal}
              onClose={() => setShowResetModal(false)}
              initialEmail={email}
              onRequestPasswordReset={onRequestPasswordReset}
              onResetPassword={onResetPassword}
            />
          )}
        </div>
      </div>
      
      {/* Right Side - Visual/Background */}
      <div className="login-visual-container" style={{ 
        flex: '0 0 50%', 
        backgroundColor: 'var(--brand-off-white)', 
        backgroundImage: 'url(/warehouse-trucks.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative'
      }}>
        {/* Warehouse image background */}
      </div>
    </div>
  );
}

// Password Reset Modal Component
function PasswordResetModal({ isOpen, onClose, initialEmail, onRequestPasswordReset, onResetPassword }) {
  const [step, setStep] = useState('request'); // 'request' or 'reset'
  const [email, setEmail] = useState(initialEmail || '');
  const [resetToken, setResetToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [generatedToken, setGeneratedToken] = useState('');

  const handleRequestToken = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    setLoading(true);
    
    try {
      const result = await onRequestPasswordReset(email);
      
      if (result.success) {
        setGeneratedToken(result.resetToken || '');
        setResetToken(result.resetToken || '');
        setStep('reset');
      } else {
        setError(result.error || 'Failed to generate reset token');
      }
      setLoading(false);
    } catch (error) {
      console.error('Request token error:', error);
      setError(error.message || 'Network error');
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!resetToken || !newPassword || !confirmPassword) {
      setError('Please fill in all fields');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }
    
    setLoading(true);
    
    try {
      const result = await onResetPassword(email, resetToken, newPassword);
      
      if (result.success) {
        alert('Password reset successful! You can now login with your new password.');
        onClose();
      } else {
        setError(result.error || 'Failed to reset password');
        setLoading(false);
      }
    } catch (error) {
      console.error('Reset password error:', error);
      setError(error.message || 'Network error');
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const brandCharcoal = 'var(--brand-charcoal)';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      fontFamily: "'NeueHaasUnica', sans-serif"
    }} onClick={onClose}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '40px',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        border: '1px solid #e5e0d9',
        position: 'relative'
      }} onClick={(e) => e.stopPropagation()}>
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666',
            padding: '0',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          ×
        </button>
        
        {step === 'request' ? (
          <form onSubmit={handleRequestToken}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '500',
              marginBottom: '8px',
              color: '#000000',
              fontFamily: "'Domaine Text', serif"
            }}>
              Reset Your Password
            </h2>
            <p style={{
              fontSize: '14px',
              color: '#666',
              marginBottom: '24px',
              lineHeight: '1.5'
            }}>
              Enter your email address and we'll generate a reset token for you to use immediately.
            </p>
            
            {error && (
              <div style={{
                backgroundColor: '#fee2e2',
                color: '#dc2626',
                padding: '12px',
                borderRadius: '6px',
                marginBottom: '24px',
                fontSize: '14px'
              }}>
                {error}
              </div>
            )}
            
            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                marginBottom: '8px',
                color: '#000000'
              }}>
                Email:
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '14px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '15px',
                  boxSizing: 'border-box',
                  backgroundColor: 'white'
                }}
                placeholder="Enter your email"
                autoFocus
              />
            </div>
            
            <div style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'flex-end'
            }}>
              <button
                type="button"
                onClick={onClose}
                style={{
                  padding: '10px 24px',
                  backgroundColor: 'transparent',
                  color: '#000000',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = brandCharcoal;
                  e.currentTarget.style.backgroundColor = '#f9fafb';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#d1d5db';
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '10px 24px',
                  backgroundColor: brandCharcoal,
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                  transition: 'all 0.2s'
                }}
              >
                {loading ? 'Generating...' : 'Generate Reset Token'}
              </button>
            </div>
          </form>
        ) : (
          <form onSubmit={handleResetPassword}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '500',
              marginBottom: '8px',
              color: '#000000',
              fontFamily: "'Domaine Text', serif"
            }}>
              Enter New Password
            </h2>
            
            {error && (
              <div style={{
                backgroundColor: '#fee2e2',
                color: '#dc2626',
                padding: '12px',
                borderRadius: '6px',
                marginBottom: '24px',
                fontSize: '14px'
              }}>
                {error}
              </div>
            )}
            
            {/* Hidden reset token field - token is stored in state and passed automatically */}
            <input
              type="hidden"
              value={resetToken}
            />
            
            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                marginBottom: '8px',
                color: '#000000'
              }}>
                New Password:
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '14px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '15px',
                  boxSizing: 'border-box',
                  backgroundColor: 'white'
                }}
                placeholder="Enter new password (min 6 characters)"
                autoFocus
              />
            </div>
            
            <div style={{ marginBottom: '32px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                marginBottom: '8px',
                color: '#000000'
              }}>
                Confirm New Password:
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '14px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '15px',
                  boxSizing: 'border-box',
                  backgroundColor: 'white'
                }}
                placeholder="Confirm new password"
              />
            </div>
            
            <div style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'flex-end'
            }}>
              <button
                type="button"
                onClick={() => {
                  setStep('request');
                  setResetToken('');
                  setNewPassword('');
                  setConfirmPassword('');
                  setError('');
                }}
                style={{
                  padding: '10px 24px',
                  backgroundColor: 'transparent',
                  color: '#000000',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = brandCharcoal;
                  e.currentTarget.style.backgroundColor = '#f9fafb';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#d1d5db';
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                Back
              </button>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '10px 24px',
                  backgroundColor: brandCharcoal,
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                  transition: 'all 0.2s'
                }}
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default Login;

